import { render, staticRenderFns } from "./input-radio-button.vue?vue&type=template&id=007b3376&scoped=true"
import script from "./input-radio-button.vue?vue&type=script&lang=js"
export * from "./input-radio-button.vue?vue&type=script&lang=js"
import style0 from "./input-radio-button.vue?vue&type=style&index=0&id=007b3376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007b3376",
  null
  
)

export default component.exports